var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbMarriedStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-married-status-icon_svg__clip0_1296_19517)",
    fill: "#1C1D1F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2a5 5 0 100 10A5 5 0 009 2zM7 14a5 5 0 00-5 5v2a1 1 0 001 1h12a1 1 0 001-1v-2a5 5 0 00-5-5H7zM15.031 2.882a1 1 0 011.217-.72 5 5 0 010 9.687 1 1 0 01-.496-1.938 3 3 0 000-5.812 1 1 0 01-.72-1.217zM18.25 14.182a1 1 0 10-.5 1.936A3 3 0 0120 19.003V21a1 1 0 102 0v-2.006a5 5 0 00-3.75-4.812z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-married-status-icon_svg__clip0_1296_19517"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbMarriedStatusIcon;